"use client";
import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Form, Input, Button, message } from "antd";
import { touristUploadFile } from "@/lib/api/media";
import { useSessionStore } from "@/lib/store/session";
import { sendForm } from "@/lib/api/form";
import { useTranslations } from "next-intl";

const { TextArea } = Input;

const SolutionContactForm = ({
	title,
	slug,
	children,
	className,
	locale,
	innerClassName,
	inquiry,
	source,
	cls,
}: {
	slug?: string;
	children?: React.ReactNode;
	title?: string;
	className?: string;
	locale: string;
	innerClassName?: string;
	inquiry?: any[] | null;
	source?: string | null;
	cls?: string | null;
}) => {
	const [loadingBtn, setLoadingBtn] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const { session_uuid } = useSessionStore();
	const [form] = Form.useForm();
	const t = useTranslations();

	const onFinish = async (values: any) => {
		try {
			const sendObj = { source: source || "contact-us", type: 0, chart: "" };
			const inquiry_info: any = {
				form: [],
				contact_method: values.email && values.mobile ? 3 : 1,
				products: [],
				html: `<h1>您的网站 <a href="${process.env.NEXT_PUBLIC_SITE_URL}" target="_blank">${process.env.NEXT_PUBLIC_SITE_URL}</a> 有新询盘，请前往网站后台查看详细内容！</h1>
<h2>询盘信息</h2>
<p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">名字：${values.name}</p>
<p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">公司：${values.company}</p>
<p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">邮箱：<a href='mailto:${values.email}' target="_blank"> ${values.email}</a></p>
<p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">手机号：<a href='https://wa.me/${values.mobile}' target="_blank"> ${values.mobile}</a></p>
<p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">留言：${values.message}</p>
`,
			};
			Object.keys(values).forEach((key) => {
				if (key === "message") {
					inquiry_info.form.push({ label: key, type: "textarea", value: values[key] });
					inquiry_info[key] = values[key];
				} else if (key === "Upload") {
					if (values[key] && values[key].length > 0) {
						const list: any[] = [];
						values[key].forEach((item: any) => {
							list.push({
								file_id: item.response.detail.file_ret[0][item.name],
								file_size: item.size,
								file_type: item.type,
								file_name: item.name,
							});
						});
						inquiry_info["files"] = list;
						inquiry_info.form.push({ label: key, type: "files", value: list });
					}
				} else {
					inquiry_info.form.push({ label: key, type: "input", value: values[key] });
					inquiry_info[key] = values[key];
				}
			});

			if (inquiry) {
				inquiry_info.form.push({ label: "inquiry", type: "inquiry", value: inquiry });
			}

			sendObj.chart = JSON.stringify({ inquiry_info });
			setLoadingBtn(true);
			const response = (await sendForm(sendObj)) as any;
			if (response && response.code === 200) {
				void message.success(t("form.sendSuccess"));
				setSubmitted(true);
				form.resetFields();
			} else {
				void message.error(response?.message || t("form.sendFail"));
			}
		} catch (error) {
			message.error(t("form.sendFail"));
		}
		setLoadingBtn(false);
	};

	const onFinishFailed = (errorInfo: any) => {
		console.error("Failed:", errorInfo);
		message.error(t("Error.inqFillTip"));
	};

	const trustPoints = [
		{
			icon: (
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-5 w-5">
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
					/>
				</svg>
			),
			label: t("contact.trust24h") || "24h Response",
		},
		{
			icon: (
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-5 w-5">
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
					/>
				</svg>
			),
			label: t("contact.trustCert") || "CE & ROHS Certified",
		},
		{
			icon: (
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-5 w-5">
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
					/>
				</svg>
			),
			label: t("contact.trustSupport") || "1-on-1 Expert Support",
		},
	];

	return (
		<div className={`inq-form-v2 mx-auto w-full max-w-[1580px] px-5 sm:px-8 lg:px-12 ${className || ""}`}>
			<style jsx global>{`
				.inq-form-v2 .ant-form-item-label > label {
					font-family: "Manrope", system-ui, sans-serif !important;
					font-size: 13px !important;
					font-weight: 600 !important;
					color: #17130f !important;
					letter-spacing: 0.02em !important;
				}
				.inq-form-v2 .ant-input,
				.inq-form-v2 .ant-input-affix-wrapper {
					border-radius: 0 !important;
					border-color: #ffe8bf !important;
					padding: 10px 14px !important;
					font-family: "Manrope", system-ui, sans-serif !important;
					font-size: 14px !important;
					color: #17130f !important;
					background: #fff !important;
					transition:
						border-color 0.2s ease,
						box-shadow 0.2s ease !important;
				}
				.inq-form-v2 .ant-input:hover,
				.inq-form-v2 .ant-input-affix-wrapper:hover {
					border-color: #ffc266 !important;
				}
				.inq-form-v2 .ant-input:focus,
				.inq-form-v2 .ant-input-affix-wrapper-focused {
					border-color: #ff9f0a !important;
					box-shadow: 0 0 0 2px rgba(255, 159, 10, 0.1) !important;
				}
				.inq-form-v2 .ant-input::placeholder {
					color: #6a5341 !important;
					opacity: 0.5 !important;
				}
				.inq-form-v2 textarea.ant-input {
					padding: 12px 14px !important;
				}
				.inq-form-v2 .ant-form-item {
					margin-bottom: 20px !important;
				}
				.inq-form-v2 .react-tel-input .form-control {
					border-radius: 0 !important;
					border-color: #ffe8bf !important;
					height: 42px !important;
					font-family: "Manrope", system-ui, sans-serif !important;
					font-size: 14px !important;
					width: 100% !important;
				}
				.inq-form-v2 .react-tel-input .form-control:hover {
					border-color: #ffc266 !important;
				}
				.inq-form-v2 .react-tel-input .form-control:focus {
					border-color: #ff9f0a !important;
					box-shadow: 0 0 0 2px rgba(255, 159, 10, 0.1) !important;
				}
				.inq-form-v2 .react-tel-input .flag-dropdown {
					border-radius: 0 !important;
					border-color: #ffe8bf !important;
					background: #fff6eb !important;
				}
			`}</style>

			<div className={`grid grid-cols-1 items-start gap-0 lg:grid-cols-[1fr_1.2fr] ${innerClassName || ""}`}>
				{/* Left — trust & context panel */}
				<div className="flex flex-col justify-between bg-brand-ink p-8 sm:p-10 lg:min-h-[560px] lg:p-12">
					<div>
						<p className="font-body text-[11px] uppercase tracking-[0.22em] text-white/50">
							{t("contact.formEyebrow") || "Get in Touch"}
						</p>
						<h3 className="mt-4 font-display text-[clamp(26px,3vw,38px)] leading-[1.14] text-white">
							{t("contact.formHeading") || "Let's Start a Conversation"}
						</h3>
						<p className="mt-5 font-body text-[14px] leading-[1.72] text-white/70 sm:text-[15px]">
							{t("contact.formDesc") ||
								"Tell us about your needs and our product specialists will craft a personalized solution for you within 24 hours."}
						</p>
					</div>

					<div className="mt-10 space-y-5 lg:mt-auto lg:pt-12">
						{trustPoints.map((point, idx) => (
							<div key={idx} className="flex items-center gap-3">
								<span className="flex h-9 w-9 shrink-0 items-center justify-center bg-white/[0.08] text-brand">
									{point.icon}
								</span>
								<span className="font-body text-[13px] font-medium tracking-wide text-white/85">
									{point.label}
								</span>
							</div>
						))}
					</div>

					<div className="mt-10 border-t border-white/10 pt-6 lg:mt-8">
						<p className="font-body text-[12px] leading-[1.6] text-white/40">
							{t("contact.formPrivacy") ||
								"Your information is kept strictly confidential and will only be used to respond to your inquiry."}
						</p>
					</div>
				</div>

				{/* Right — form panel */}
				<div className="bg-white p-8 sm:p-10 lg:p-12">
					{submitted ? (
						<div className="flex min-h-[400px] flex-col items-center justify-center text-center">
							<span className="mb-5 flex h-16 w-16 items-center justify-center bg-brand-tint text-brand">
								<svg
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth="1.5"
									className="h-8 w-8"
								>
									<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
								</svg>
							</span>
							<h4 className="font-display text-[24px] leading-[1.2] text-brand-ink">
								{t("form.thankYouTitle") || "Thank You!"}
							</h4>
							<p className="mt-3 max-w-[38ch] font-body text-[14px] leading-[1.68] text-brand-muted">
								{t("form.thankYouDesc") ||
									"Your message has been received. Our team will get back to you within 24 hours."}
							</p>
							<button
								onClick={() => setSubmitted(false)}
								className="mt-8 font-body text-[13px] font-semibold tracking-wide text-brand underline underline-offset-4 transition-colors hover:text-brand-accent"
							>
								{t("form.sendAnother") || "Send another message"}
							</button>
						</div>
					) : (
						<Form
							form={form}
							layout="vertical"
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							initialValues={{ remember: true }}
						>
							<div className="grid grid-cols-1 gap-x-6 sm:grid-cols-2">
								<Form.Item
									name="name"
									label={t("form.name")}
									rules={[{ required: true, message: t("form.pleaseName") }]}
								>
									<Input placeholder={t("form.nameTip")} />
								</Form.Item>
								<Form.Item
									name="company"
									label={t("form.company")}
									rules={[{ required: true, message: t("form.pleaseCompany") }]}
								>
									<Input placeholder={t("form.companyTip")} />
								</Form.Item>
							</div>
							<div className="grid grid-cols-1 gap-x-6 sm:grid-cols-2">
								<Form.Item
									name="email"
									label={t("form.email")}
									rules={[
										{ required: true, message: t("form.pleaseEmail") },
										{ type: "email", message: t("form.vailEmailTip") },
									]}
								>
									<Input placeholder={t("form.emailTip")} />
								</Form.Item>
								<Form.Item
									name="mobile"
									label={t("form.phone")}
									rules={[{ required: true, message: t("form.pleasePhone") }]}
								>
									<PhoneInput country={"us"} enableSearch inputStyle={{ width: "100%" }} buttonStyle={{}} />
								</Form.Item>
							</div>
							<Form.Item
								name="message"
								label={t("form.message")}
								rules={[
									{ required: true, message: t("form.pleaseMessage") },
									{
										validator: (_, value) =>
											value && value.length > 4
												? Promise.resolve()
												: Promise.reject(new Error("The message must be longer than 4 characters")),
									},
								]}
							>
								<TextArea rows={5} placeholder={t("form.messageTip")} />
							</Form.Item>

							<Form.Item className="!mb-0 !mt-2">
								<button
									type="submit"
									disabled={loadingBtn}
									className="group relative w-full overflow-hidden bg-brand py-3.5 font-body text-[14px] font-semibold tracking-wide text-brand-ink transition-all duration-300 hover:bg-brand-accent hover:text-white disabled:opacity-60"
								>
									<span className="relative z-10 flex items-center justify-center gap-2">
										{loadingBtn ? (
											<svg className="h-5 w-5 animate-spin" viewBox="0 0 24 24" fill="none">
												<circle
													className="opacity-25"
													cx="12"
													cy="12"
													r="10"
													stroke="currentColor"
													strokeWidth="4"
												/>
												<path
													className="opacity-75"
													fill="currentColor"
													d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
												/>
											</svg>
										) : null}
										{t("base.Submit")}
									</span>
								</button>
							</Form.Item>
						</Form>
					)}
				</div>
			</div>
			{children}
		</div>
	);
};

export default SolutionContactForm;
